// extracted by mini-css-extract-plugin
module.exports = {"selectedItemsGrid":"ShowcaseItemsInput_selectedItemsGrid__hL1H9","selectedItemRemove":"ShowcaseItemsInput_selectedItemRemove__hM2xy"};